module.exports = __webpack_public_path__ + "2e6bf13d2dd31864ffd4cd5eef455ffe.svg";